var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachFile24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6V16.5C15.5 18.71 13.71 20.5 11.5 20.5C9.29 20.5 7.5 18.71 7.5 16.5V6C7.5 4.62 8.62 3.5 10 3.5C11.38 3.5 12.5 4.62 12.5 6V15.5C12.5 16.05 12.05 16.5 11.5 16.5C10.95 16.5 10.5 16.05 10.5 15.5V6H9V15.5C9 16.88 10.12 18 11.5 18C12.88 18 14 16.88 14 15.5V6C14 3.79 12.21 2 10 2C7.79 2 6 3.79 6 6V16.5C6 19.54 8.46 22 11.5 22C14.54 22 17 19.54 17 16.5V6H15.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFile24Px);
export default __webpack_public_path__ + "static/media/attach_file_24px.ee59920ca4abe553797dc0eea24a9be1.svg";
export { ForwardRef as ReactComponent };